import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, LaptopIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 THE 100 LEGAL PRECEDENTS AI™',
  ideal: 'Solo Practitioners, Partners, and Associates who want to protect their career and reclaim their time.',
  was: '$180',
  now: '27',
  features: ['Full 6-Volume Strategic System', '100+ Ready-to-use Attorney-Vetted Prompts', 'Instant compatibility with ChatGPT, Claude, Gemini & DeepSeek', '4 Free Professional Bonuses included', '30-Day Risk-Free Guarantee', '♾️ Lifetime Access & Free Updates'],
  cta: 'Get the 100 Legal Precedents AI™ now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: LaptopIcon,
  label: 'Mobile & Tablet'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-120" data-mp="3canypub5biyd">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-121" data-mp="4t5k78y411wg">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-122" data-mp="9rz1lcgipd1w">
          <p className="font-display text-xl font-black text-plum" data-id="element-123" data-mp="9qe2ran677y8">🔥 Limited Offer — Ending Soon!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-124" data-mp="3d8z3twnqmthq">
            ⚠️ After this, the price returns to $54. This rate will not come back.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-125" data-mp="3i8k01zbiwnqr">
            🎟️ Only 7 spots left at this price!
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(107,16,34,0.5)]" data-id="element-126" data-mp="3rzy7ct9purug">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-127" data-mp="3164twzg3dp4h">
            <h3 className="font-display text-base font-black text-white" data-id="element-128" data-mp="2w8mhv06s2ts9">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-129" data-mp="28j1wkan5jkft">
            <span className="font-semibold text-plum/80" data-id="element-130" data-mp="28jtsxnokpm75">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-131" data-mp="23la6zn9zcaes">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-132" data-mp="2iggd0a92s984">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-133" data-mp="2dgu0k312mx0d">
              <span className="relative inline-block font-display leading-none" data-id="element-134" data-mp="2djg5rw0hp0ff">
                <span className="absolute right-full top-1/2 mr-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-135" data-mp="3ttikmft75og5">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-136" data-mp="5a0055ejtjug">
                  {plan.now}
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-137" data-mp="3rirf5fgmd3ja">
              · One-time payment · Lifetime Access ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-138" data-mp="nzomia4c3ry7">
              · Payment will be processed in your local currency ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-139" data-mp="ea5578w9s65g">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-140" data-mp="e7sdi40pmhf7">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-141" data-mp="11xmpkjd7g1ye" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-142" data-mp="3f81tiz139apx">
            <CTAButton size="md" data-id="element-143" data-mp="3f5fnj3tuj39t">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-144" data-mp="3a6uj0s7k9xfk">
            Save $153 (85% OFF)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-145" data-mp="359mc5nrv5ftm">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="1rud5pfb7vlx">
                <Icon className="h-4 w-4 text-grape" data-id="element-147" data-mp="3t086ydcux3lo" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-148" data-mp="3o63y1ok16lhy">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-149" data-mp="kjdelrtor1lu" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-150" data-mp="fsexiq0vhzhj">
            <span className="font-display font-bold text-plum" data-id="element-151" data-mp="fr3tqq7fgrqf">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel that this system doesn't save you at least 2 hours of drafting per day, just ask for a refund. We will return 100% of your money, no questions asked. SIGMA SMART™ is committed to your practice's protection.
          </p>
        </div>
      </div>
    </section>;
}